<div class="legend-items d-flex align-items-center justify-content-start full-height">
  <div class="legend-item d-flex align-items-center justify-content-start" *ngFor="let legend of legendItems">
    <div class="map-icon {{legend.className}}"></div>
    <div class="text-small-normal">{{legend.text | amdocsTranslate}}</div>
  </div>
</div>
